import React from "react";
import Content from "./Elements/Content";
import Block from "./Elements/Block";

import styles from "./Sources.module.scss";
import ImageText from "./Elements/ImageText";

import src from "../images/disclaimer.jpg";
import srcRet from "../images/disclaimer@2x.jpg";
import webp from "../images/disclaimer.webp";
import webpRet from "../images/disclaimer@2x.webp";
import Button from "./Global/Button";

export default function Sources() {
    return (
        <Content>
            <Block classname={styles.Disclaimer} background={'black'} container={false}>
                <div className="container">
                    <ImageText image={{...{src, srcRet, webp, webpRet}}} radius={true} classname={'rtl'}>
                    <span className={'subtitle'}>
                        Vous souhaitez investir
                        dans les voitures autonomes ?
                    </span>

                        <p>
                            Avec e-toro, adoptez une approche intelligente et innovante de l’investissement personnel.
                            <br/>
                            Choisissez un portefeuille équilibré et entièrement alloué, axé sur les segments de marché que
                            vous pouvez comprendre et auxquels vous pouvez vous identifier.
                        </p>

                        <Button text={"Découvrir le portefeuille et ses performances"}
                                url={'https://ad.doubleclick.net/ddm/clk/516215774;324089622;j'} target={'_blank'}/>
                    </ImageText>
                </div>

                <div className={[styles.Message, 'container'].join(' ')}>
                    <p className={"mb-0"}>
                        <small>
                            Cette communication est uniquement destinée à des fins d'information et d'éducation et ne doit pas être considérée comme un conseil d'investissement,
                            une recommandation personnelle, ou une offre ou une sollicitation d'achat ou de vente d'instruments financiers. Votre capital est assujetti à un risque.
                        </small>
                    </p>
                </div>
            </Block>

            <Block classname={styles.Main} title={'Sources'} container={true}>
                <ul>
                    <li>
                        <a href="https://www.iddri.org/sites/default/files/PDF/Publications/Catalogue%20Iddri/Propositions/201804-PB0218FR-autonomous%20mobility_0.pdf"
                           target={'_blank'} rel="noreferrer">
                            https://www.iddri.org/sites/default/files/PDF/Publications/Catalogue%20Iddri/Propositions/201804-PB0218FR-autonomous%20mobility_0.pdf
                        </a>
                    </li>
                    <li>
                        <a href="https://www.ecologie.gouv.fr/sites/default/files/2018.05.14_rapport_vehicules_autonomes.PDF"
                           target={'_blank'} rel="noreferrer">
                            https://www.ecologie.gouv.fr/sites/default/files/2018.05.14_rapport_vehicules_autonomes.PDF
                        </a>
                    </li>
                    <li>
                        <a href="https://www.actu-environnement.com/media/pdf/news-37182-rapport-idrac-vehicule-autonome-mai-2018.pdf"
                           target={'_blank'} rel="noreferrer">
                            https://www.actu-environnement.com/media/pdf/news-37182-rapport-idrac-vehicule-autonome-mai-2018.pdf
                        </a>
                    </li>
                    <li>
                        <a href="https://www.ncsl.org/research/transportation/autonomous-vehicles-self-driving-vehicles-enacted-legislation.aspx"
                           target={'_blank'} rel="noreferrer">
                            https://www.ncsl.org/research/transportation/autonomous-vehicles-self-driving-vehicles-enacted-legislation.aspx
                        </a>
                    </li>
                </ul>
            </Block>
        </Content>
    )
}
